import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { RouteWithLayout } from './components'
import { PrivateRouteWithLayout, RedirectNovoSistema } from './components'
import {
  Main as MainLayout,
  MainPrincipal as MainPrincipalLayout,
  Minimal as MinimalLayout,
  MainModules as MainModulesLayout
} from './layouts'
import rotasMigradas, { montarDestino } from './rotasMigradas'

// Só as telas que ainda não existem no web novo. As migradas estão em rotasMigradas.js.
import {
  Ajuda as AjudaView,
  CampanhaInstrucoes as CampanhaInstrucoesView,
  CategoriaProduto as CategoriaProdutoView,
  Checklist as ChecklistView,
  ChecklistEdit as ChecklistEditView,
  Criamigos as CriamigosView,
  EmailVerification as EmailVerificationView,
  Error404 as Error404View,
  PasswordReset as PasswordResetView,
  PasswordResetSuccess as PasswordResetSuccessView,
  Login as LoginView,
  PedidoCompraRecebidoEdit as PedidoCompraRecebidoEditView,
  Principal as PrincipalView,
  ProdutoCompraEdit as ProdutoCompraEditView,
  RelatorioChecklist as RelatorioChecklistView,
  RelatorioChecklistDiario as RelatorioChecklistDiarioView,
  RelatorioChecklistOperacao as RelatorioChecklistOperacaoView,
  RelatorioTotvsInsumoUnidadeFornecedor as RelatorioTotvsInsumoUnidadeFornecedorView,
  Retrospectiva as RetrospectivaView,
} from './views'

const Routes = () => {
  return (
    <Switch>
      {/* Telas migradas para o web novo: precisam vir antes das demais (ex.: /campanha/edit antes de /campanha/:id) */}
      {rotasMigradas.map(({ path, to }) => (
        <Route
          exact
          key={path}
          path={path}
          render={({ match }) => <RedirectNovoSistema to={montarDestino(to, match.params)} />}
        />
      ))}
      <Route
        component={CampanhaInstrucoesView}
        exact
        path="/campanha"
      />
      <Route
        component={CampanhaInstrucoesView}
        exact
        path="/campanha/:id"
      />
      <PrivateRouteWithLayout
        component={CategoriaProdutoView}
        exact
        layout={MainModulesLayout}
        type="F"
        path="/categoriasProdutos"
      />
      {/*<PrivateRouteWithLayout*/}
      {/*  component={HomeView}*/}
      {/*  exact*/}
      {/*  layout={MainModulesLayout}*/}
      {/*//  type={changeValueType}*/}
      {/*  path="/home"*/}
      {/*/>*/}
      <PrivateRouteWithLayout
        component={ChecklistView}
        exact
        layout={MainModulesLayout}
        type="P"
        path="/checklists"
      />
      <PrivateRouteWithLayout
        component={ChecklistEditView}
        exact
        layout={MainModulesLayout}
        type="P"
        path="/checklist"
      />
      <PrivateRouteWithLayout
        component={ChecklistEditView}
        exact
        layout={MainModulesLayout}
        type="P"
        path="/checklist/:id"
      />
      <PrivateRouteWithLayout
        component={PrincipalView}
        exact
        layout={MainPrincipalLayout}
        path="/principal"
      />
      <PrivateRouteWithLayout
        component={PrincipalView}
        exact
        layout={MainPrincipalLayout}
        path="/"
      />
      <PrivateRouteWithLayout
        component={RelatorioChecklistView}
        exact
        layout={MainModulesLayout}
        type="P"
        path="/relatorioChecklist/:id"
      />
      <PrivateRouteWithLayout
        component={RelatorioChecklistDiarioView}
        exact
        layout={MainModulesLayout}
        type="P"
        path="/relatorioChecklistDiario/:id"
      />
      <PrivateRouteWithLayout
        component={RelatorioChecklistOperacaoView}
        exact
        layout={MainModulesLayout}
        type="O"
        path="/relatorioChecklistOperacao/:id/:dataInicio/:dataFim"
      />
      <PrivateRouteWithLayout
        component={RelatorioTotvsInsumoUnidadeFornecedorView}
        exact
        layout={MainModulesLayout}
        type="P"
        path="/relatorioTotvsInsumosUnidadesFornecedores"
      />
      <PrivateRouteWithLayout
        component={ProdutoCompraEditView}
        exact
        layout={MainModulesLayout}
        type="O"
        path="/produtoCompra/:id"
      />
      <Route component={LoginView} exact path="/login" />
      <Route component={RetrospectivaView} exact path="/retrospectiva" />
      <Route component={CriamigosView} exact path="/criamigos" />
      {/*<Route component={VilaDaMonicaView} exact path="/viladamonica" />*/}
      {/*<Route component={YoucomView} exact path="/youcom" />*/}
      <RouteWithLayout
        component={PedidoCompraRecebidoEditView}
        exact
        layout={MinimalLayout}
        path="/pedidoCompra/recebido/:id"
      />
      <Route
        component={AjudaView}
        exact
        path="/ajuda"
      />
      <Route
        component={EmailVerificationView}
        exact
        path="/email-verification"
      />
      <Route
        component={PasswordResetView}
        exact
        path="/password-reset"
      />
      <Route
        component={PasswordResetSuccessView}
        exact
        path="/password-reset-success"
      />
      {/*<PrivateRouteWithLayout*/}
      {/*  component={HomeView}*/}
      {/*  exact*/}
      {/*  layout={MainLayout}*/}
      {/*  path="/"*/}
      {/*/>*/}
      <RouteWithLayout
        component={AjudaView}
        exact
        layout={MinimalLayout}
        path="/ajuda"
      />
      <RouteWithLayout
        component={Error404View}
        exact
        layout={MinimalLayout}
        path="/not-found"
      />
      <Redirect to="/not-found" />
    </Switch>
  )
}

export default Routes
